module.exports = __webpack_public_path__ + "img/Cordova.b9ddddaf.jpeg";